export default __webpack_public_path__ + "static/media/w_f_2024_h.1aa186da.jpg";